import React from 'react'
import "../style/Carousel.css";
function Carousel({carouselItems}) {
  return (
    <div id="dynamicCarousel" className="carousel slide p-3 shadow rounded bg-light" data-bs-ride="carousel">
      {/* Indicators/Dots */}
      <div className="carousel-indicators">
        {carouselItems && carouselItems.map((_, index) => (
          <button
            key={index}
            type="button"
            data-bs-target="#dynamicCarousel"
            data-bs-slide-to={index}
            className={index === 0 ? "active" : ""}
            aria-current={index === 0 ? "true" : "false"}
            aria-label={`Slide ${index + 1}`}
          ></button>
        ))}
      </div>

      {/* Carousel Items */}
      <div className="carousel-inner rounded" style={{maxHeight:"550px"}}>
        {carouselItems && carouselItems.map((item, index) => (
          <div
            key={index}
            className={`carousel-item ${index === 0 ? "active" : ""}`}
          >
            <img src={item.src} alt={item.alt} className="my-auto" style={{maxHeight:"550px",objectFit:"cover"}}  />
            <div className="carousel-caption d-none d-md-block mb-4">
              <h5>{item.label}</h5>
            </div>
          </div>
        ))}
      </div>

      {/* Controls */}
      <button
        className="carousel-control-prev my-auto"
        type="button"
        data-bs-target="#dynamicCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next my-auto"
        type="button"
        data-bs-target="#dynamicCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  )
}

export default Carousel